import { ACCESS_TOKEN_KEY } from '@/utils/auth-keys';
import { safeSessionGet, safeSessionRemove, safeSessionSet } from '@/utils/session-storage';

export const readAccessToken = (): string | null => safeSessionGet(ACCESS_TOKEN_KEY);

export const writeAccessToken = (token: string): void => safeSessionSet(ACCESS_TOKEN_KEY, token);

export const clearAccessToken = (): void => safeSessionRemove(ACCESS_TOKEN_KEY);
